/**
 * VideoPause
 *
 * To enable a user to pause or restart an autoplaying video
 */

class VideoPause {
  constructor() {
    this.initialize();
  }

  initialize() {
    const videos = document.querySelectorAll('.wp-block-video video, .home-topper__video');

    videos.forEach(video => {
      const autoplay = video.hasAttribute('autoplay');

      const videoID = video.getAttribute('id') || `video-${crypto.randomUUID()}`;

      // If the video has autoplay attribute, add a play/pause button
      if (autoplay) {
        video.setAttribute('data-state', 'playing');
        const pauseButton = document.createElement('button');
        pauseButton.textContent = 'Pause';
        pauseButton.classList.add('video-pause-button');
        pauseButton.setAttribute('aria-controls', videoID);
        video.setAttribute('id', videoID);

        let hiddenPauseButton = document.querySelector('.video-pause-button');

        if (!hiddenPauseButton) {
          hiddenPauseButton = pauseButton.cloneNode(true);
          hiddenPauseButton.classList.add('video-pause-button');
          hiddenPauseButton.classList.add('skip-to-content');
          hiddenPauseButton.textContent = 'Pause Video';

          const skipLinksNav = document.getElementById('skip-links');
          if (skipLinksNav) {
            skipLinksNav.appendChild(hiddenPauseButton);
          } else {
            // If skip-links nav doesn't exist, insert at the top of the body
            document.body.insertBefore(hiddenPauseButton, document.body.firstChild);
          }
        } else {
          const hiddenAriaControls = hiddenPauseButton.getAttribute('aria-controls');
          hiddenPauseButton.setAttribute('aria-controls', `${hiddenAriaControls} ${videoID}`);
        }

        // Add click event listener to the button
        pauseButton.addEventListener('click', () => this.togglePlayPause(video, pauseButton));
        hiddenPauseButton.addEventListener('click', () => this.togglePlayPause(video, pauseButton));

        // Append the button inside the figure element
        const figure = video.closest('.wp-block-video, .home-topper__figure');
        if (figure) {
          figure.appendChild(pauseButton);
        }

        // Set tabIndex="-1" to make the video unfocusable via keyboard tabbing
        video.tabIndex = -1;

        // If prefers reduced motion is set, pause the video.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play();
          this.togglePlayPause(video, pauseButton);
        }
      }
    });
  }

  // Function to toggle play/pause and update button text
  togglePlayPause(video, pauseButton) {
    pauseButton.blur();
    if (video.paused) {
      video.play();
      pauseButton.textContent = 'Pause';
      video.setAttribute('data-state', 'playing');
    } else {
      video.pause();
      pauseButton.textContent = 'Play';
      video.setAttribute('data-state', 'paused');

      const hiddenPauseButton = document.querySelector('.video-pause-button');

      if (hiddenPauseButton) {
        hiddenPauseButton.remove();
      }
    }
  }
}

export default VideoPause;
